/* VYRN disc golf landing page helpers: lite YouTube, sub-nav highlight, QR welcome banner. */
(function () {
  if (window.VyrnDisc) return;
  window.VyrnDisc = true;

  // Click-to-load YouTube (keeps the page fast on phones)
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-vd-yt]');
    if (!btn) return;
    var id = btn.getAttribute('data-vd-yt');
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&playsinline=1&rel=0';
    iframe.title = btn.getAttribute('data-title') || 'YouTube video';
    iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    iframe.className = 'vd-video__iframe';
    btn.replaceWith(iframe);
  });

  // Highlight the sub-nav chip for the section in view
  function initSubnav(root) {
    var navs = (root || document).querySelectorAll('[data-vd-subnav]');
    if (!('IntersectionObserver' in window)) return;
    navs.forEach(function (nav) {
      if (nav._vdObserver) nav._vdObserver.disconnect();
      var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
      var map = new Map();
      links.forEach(function (link) {
        var target = document.getElementById(link.getAttribute('href').slice(1));
        if (target) map.set(target, link);
      });
      if (!map.size) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          links.forEach(function (l) { l.classList.remove('is-active'); });
          var active = map.get(entry.target);
          active.classList.add('is-active');
          var list = active.parentElement && active.parentElement.parentElement;
          if (list && list.scrollTo) {
            list.scrollTo({ left: active.parentElement.offsetLeft - 16, behavior: 'smooth' });
          }
        });
      }, { rootMargin: '-40% 0px -55% 0px' });
      map.forEach(function (_, target) { observer.observe(target); });
      nav._vdObserver = observer;
    });
  }

  // Show a welcome banner for QR traffic, e.g. /pages/disc-golf?ref=hole10
  function initQr() {
    if (document.querySelector('.vd-qr-banner')) return;
    var params = new URLSearchParams(window.location.search);
    var ref = (params.get('ref') || params.get('utm_content') || '').toLowerCase();
    if (!ref) return;
    var templates = document.querySelectorAll('template[data-vd-qr]');
    for (var i = 0; i < templates.length; i++) {
      if (templates[i].getAttribute('data-vd-qr').toLowerCase() !== ref) continue;
      var main = document.getElementById('MainContent') || document.querySelector('main');
      if (main) main.prepend(templates[i].content.cloneNode(true));
      break;
    }
  }

  function init() { initSubnav(); initQr(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { initSubnav(); });
})();
